
import { defineComponent, watchEffect, inject, PropType } from 'vue';
import PanelHeader from '@/components/panel-header.vue';
import focus from '@/libs/focus';
import { ToastPluginApi } from 'vue-toast-notification';
import { useI18n } from 'vue-i18n';
import { PasswordResetErrorCode } from '@/password/passwordState';
import {
  LABEL_CONTINUE,
  LABEL_TWO_FACTOR_AUTHENTICATION,
  LABEL_OPEN_YOUR_TIME_BASED_ONE_TIME_PASSWORD,
  LABEL_ENTER_ONE_OF_YOUR_BACKUP_CODES,
} from '@/libs/i18nLabels';

export default defineComponent({
  components: {
    PanelHeader,
  },

  data() {
    return {
      code: '',
    };
  },

  props: {
    errorCode: Object as PropType<PasswordResetErrorCode>,
    processing: Boolean,
  },

  emits: ['codeSubmitted', 'backupCodeSubmitted'],

  setup(props) {
    const toast: ToastPluginApi | undefined = inject('$toast');
    const i18n = useI18n();

    watchEffect(() => {
      if (props.errorCode === PasswordResetErrorCode.TOTPInvalidBackupCode) {
        toast?.open({ message: i18n.t('Password.TOTP_invalid_code'), type: 'error', duration: 5000, position: 'top' });
      }
    });

    return { LABEL_CONTINUE, LABEL_TWO_FACTOR_AUTHENTICATION, LABEL_OPEN_YOUR_TIME_BASED_ONE_TIME_PASSWORD, LABEL_ENTER_ONE_OF_YOUR_BACKUP_CODES };
  },

  methods: {
    validate() {
      if (this.code.length === 0) {
        this.focusCode();
        return;
      }

      this.$emit('codeSubmitted', this.code);
    },

    focusCode() {
      focus(this.$refs.codeField);
    },

    displayBackupCode() {
      // eslint-disable-next-line no-alert
      const backupCode = window.prompt(this.$t('Password.Enter_one_of_your_backup_codes'));
      if (!backupCode || backupCode.trim().length === 0) {
        return;
      }
      this.code = '';
      this.$emit('backupCodeSubmitted', backupCode);
    },
  },

  computed: {
    isCodeInvalid() {
      return this.errorCode === PasswordResetErrorCode.TOTPInvalidCode;
    },

    codeLabel() {
      if (this.isCodeInvalid) {
        this.focusCode();
        return this.$t('Password.TOTP_invalid_code');
      }

      return undefined;
    },
  },

  mounted() {
    this.focusCode();
  },
});
